// Photo filenames for 20th Anniversary Party
const BAKER_TRANS_DAY_PHOTOS = [
    "events-baker-trans-day-6_15602949424_z.jpg",
    "events-baker-trans-day-7_16037841468_z.jpg",
    "events-baker-trans-day-8_16037989600_z.jpg",
    "events-baker-trans-day-9_16039241219_z.jpg",
    "events-baker-trans-day-10_15605499413_z.jpg",
    "events-baker-trans-day-11_15605499393_w.jpg",
    "events-bert-baker-event-promo_16039513167_l.jpg",
    "events-baker-trans-day_16223483071_z.jpg",
    "events-baker-trans-day-1_16225345575_z.jpg",
    "events-baker-trans-day-2_16039513617_z.jpg",
    "events-baker-trans-day-3_16039241319_z.jpg",
    "events-baker-trans-day-4_15602949484_z.jpg",
    "events-baker-trans-day-5_16224539562_z.jpg"
];

export default BAKER_TRANS_DAY_PHOTOS;
